<template>
  <v-container
    fluid
    :style="{
      'background-color': $store.getters.getColorPalette().backgroundColorCode,
    }"
  >
    <v-row>
      <v-col cols="12">
        <QueryParamMapTable />
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import QueryParamMapTable from "@/components/lists/derived/QueryParamMapTable";
export default {
  name: "QueryParamMapPage",
  components: {
    QueryParamMapTable,
  },
};
</script>
